export const SIGN_OUT_PARAMETER = 'signOut'
export const REDIRECT_TO_PARAMETER = 'redirectTo'
